<template>
  <el-row class="core_one_wrap">
    <el-col class="one_left">
      <img src="@/assets/img/coreCompetence/cs-2.jpg" alt="">
    </el-col>
    <el-col class="one_right">
      <div class="left_tit">
        职业高考
      </div>
      <ul class="left_desc">
        <div>职教高考，也叫职业教育高考，是相对于普通高考（普通高等学校招生全国统一考试）一种高考形式，是职业教育的专门性高考。教育部逐步建立职教高考制度，使之成为高职考试招生主渠道。</div>
      </ul>

    </el-col>

  </el-row>
</template>

<script>
export default {
  data() {
    return {
      cardList: [
        {
          icon: 'icon-chanyelian-shengwuyiyao',
          txt: '生物医药',
        },
        {
          icon: 'icon-shengchanzhizao',
          txt: '高端装备制造',
        },
        {
          icon: 'icon-lvye',
          txt: ' 新能源',
        },
        {
          icon: 'icon-zu',
          txt: ' 新材料',
        },
        {
          icon: 'icon-dc-icon-xinxijishu',
          txt: '新一代信息技术',
        },
        {
          icon: 'icon-jienenghuanbao',
          txt: ' 节能环保',
        },
        {
          icon: 'icon-shuzichuangyi',
          txt: '数字创意',
        },
        {
          icon: 'icon-fenzishi',
          txt: '科技服务业务',
        },
        {
          icon: 'icon-xinnengyuan',
          txt: '新能源汽车',
        },
      ],
    }
  },
}
</script>

<style lang="scss" scoped>
.core_one_wrap {
  height: 440px;
  display: flex;
  justify-content: center;
  text-align: left;
  margin-bottom: 30px;
  background: #282828;
  padding-top: 60px;
  padding-bottom: 50px;

  @media screen and (max-width: 768px) {
    flex-wrap: wrap;
  }
  .one_right {
    width: 40%;
    @media screen and (max-width: 768px) {
      width: 90%;
    }
    .left_tit {
      font-size: 30px;
      font-weight: bold;
      color: #EB6629;
      margin-bottom: 20px;
      @media screen and (max-width: 768px) {
        font-size: 1.2rem;
        margin-top: 20PX;
      }
    }

    .left_desc {
      color: #fff;

      font-size: 18px;
      line-height: 30PX;
      li {
        line-height: 25PX;
      }
      @media screen and (max-width: 768px) {
        font-size: 14px;
      }
    }

    .left_card {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      margin-top: 25px;
      margin-right: 80px;
      @media screen and (max-width: 768px) {
        margin: 0;
      }
      .card_item {
        box-sizing: border-box;
        width: 30%;
        height: 50px;
        background: #fff;
        box-shadow: 0 -0.0625rem 0.4375rem 0 silver,
        0 0 0.75rem 0 rgb(0 0 0 / 10%);
        display: flex;
        align-items: center;
        color: #0991d3;
        padding: 0 20px;
        cursor: pointer;
        @media screen and (max-width: 768px) {
          height: 50PX;
        }
        i{
          font-size: 1.3rem;
        }
        &:nth-child(n + 4) {
          margin-top: 30px;
          @media screen and (max-width: 768px) {
            margin-top: 16PX;
          }
        }
        &:hover .item_txt {
          letter-spacing: 4px;
        }
        .item_txt {
          width: 100%;
          font-weight: bold;
          font-size: 17px;
          margin-left: 10px;
          transition: all 1s;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          @media screen and (max-width: 768px) {
            font-size: 14px;
          }
        }
      }
    }
  }

  .one_left {
    width: 25%;
    height: 100%;
    margin-right: 5%;
    @media screen and (max-width: 768px) {
      width: 70%;
    }
    img{
      width: 100%;
    }
  }
}
</style>